/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as EmbedExternal from './external.defs'
import * as RepoStrongRef from '../../../com/atproto/repo/strongRef.defs'

const $nsid = 'app.bsky.embed.getEmbedExternalView'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  url: /*#__PURE__*/ l.string({ format: 'uri' }),
  uris: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'at-uri' }), {
    maxLength: 4,
  }),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  view: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<EmbedExternal.View>((() => EmbedExternal.view) as any),
  ),
  associatedRefs: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<RepoStrongRef.Main>(
        (() => RepoStrongRef.main) as any,
      ),
    ),
  ),
  associatedRecords: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.lexMap()),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Resolve one or more AT-URIs into the data needed to render an enhanced external embed. Returns `associatedRefs` (strongRefs to embed into a post's external.associatedRefs), the raw `associatedRecords`, and a hydrated `view`. The response is empty (`{}`) when no records were resolvable, or when validation determined the resolved records don't actually back the requested URL; clients should fall back to their own link-card rendering in that case and skip writing strongRefs to the post. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
